import React from 'react';

const SvgSchedule = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 5H3C2.44772 5 2 5.44772 2 6V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V6C22 5.44772 21.5523 5 21 5Z"
        stroke="#514B4D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 3V7M12.5 11.5H7M17 15.5H7M17 3V7" stroke="#514B4D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default SvgSchedule;
